function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Sortable from 'sortablejs/modular/sortable.core.esm.js';

Sage.sortable = function () {
  // ==================================================
  // Variables
  // ==================================================
  var SELECTOR_CONTAINER = 'data-js-sortable';
  var SELECTOR_ITEM_UPDATE_URL = 'data-js-sortable-update-url';
  var SETTINGS = {
    ghostClass: 'sage-sortable__item--ghost',
    chosenClass: 'sage-sortable__item--active'
  }; // ==================================================
  // Functions
  // ==================================================

  function init(el) {
    var resourceName = el.getAttribute(SELECTOR_CONTAINER);
    if (!resourceName) return console.error("Sage Sortable requires a resource name \n\n EXAMPLE: \n [".concat(SELECTOR_CONTAINER, "=\"resourceName\"]"));
    Sortable.create(el, _objectSpread(_objectSpread({}, SETTINGS), {}, {
      onEnd: function onEnd(evt) {
        var updateUrl = evt.item.getAttribute(SELECTOR_ITEM_UPDATE_URL); // Check if the sorted Item:
        // - Has a [data-js-sortable-update-url="url-here"] attr
        // - Didn't have the same index as its new index

        if (!updateUrl || evt.oldIndex == evt.newIndex) return;
        var params = new URLSearchParams();
        params.append('_method', 'PUT');
        params.append("".concat(resourceName, "[sort_position]"), evt.newIndex);
        Sage.util.ajaxRequestWithJsInjection('POST', updateUrl, params);
      }
    }));
  }

  function unbind(el) {
    var sortableInstance = Sortable.get(el);
    sortableInstance.destroy();
  }

  return {
    init: init,
    unbind: unbind
  };
}();